import React, { useEffect, useState } from 'react';
import { Button, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useProfile } from '../../hooks';
import { logout } from '../../apiCalls/user/user';
import {
  revokeToken,
  setUserId,
  setMobileNumber,
  getMobileNumber
} from '../../utils/session-utils';
import routes from '../../constants/routes';
import { withLocal } from '../common/LocaleProvider/LocaleProvider';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px'
  },
  header: {
    margin: '16px 0px',
    fontFamily: 'times',
    color: theme.palette.primary.dark
  }
}));

const SignOut = ({ history, locale }) => {
  const classes = useStyles();
  const { clearProfile } = useProfile();
  const [error, setError] = useState(false);

  useEffect(() => {
    logout(
      {
        mobileNumber: getMobileNumber()
      },
      () => {
        clearProfile();
        revokeToken();
        setUserId(null);
        setMobileNumber(null);
        setError(false);
      },
      () => setError(true)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <h1 className={classes.header}>{locale.header}</h1>
        {!error ? (
          <h4>{locale.sign_out.message}</h4>
        ) : (
          <span>{locale.sign_out.error}</span>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push(routes.HOME_PAGE)}
        >
          {locale.button_labels.to_home_page}
        </Button>
      </Paper>
    </div>
  );
};

export default withLocal(SignOut);
